import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgMapNeedle = (props: ISvgProps) => {
    return (
        <svg
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <g clipPath="url(#clip0_34_418)">
                <path
                    d="M27 13.5479C27 18.179 10.125 27 10.125 27C10.125 27 7.59375 18.179 7.59375 13.5479C7.59375 11.9688 8.61604 10.4543 10.4358 9.3377C12.2554 8.22108 14.7234 7.59375 17.2969 7.59375C19.8703 7.59375 22.3384 8.22108 24.158 9.3377C25.9777 10.4543 27 11.9688 27 13.5479Z"
                    fill="#1C1D28"
                    fillOpacity="0.2"
                />
                <path
                    d="M20.25 9.77586C20.25 15.1749 10.125 27 10.125 27C10.125 27 0 15.1749 0 9.77586C0 4.37678 4.53313 0 10.125 0C15.7169 0 20.25 4.37678 20.25 9.77586Z"
                    fill="#53F293"
                />
                <path
                    d="M19.8281 9.77586C19.8281 11.0195 19.2366 12.6947 18.2919 14.5538C17.355 16.3972 16.1015 18.3636 14.8414 20.1714C13.5823 21.9775 12.3225 23.6169 11.3769 24.8053C10.9043 25.3993 10.5106 25.8801 10.2353 26.212C10.1961 26.2594 10.1593 26.3037 10.125 26.3447C10.0907 26.3037 10.0539 26.2594 10.0147 26.212C9.73941 25.8801 9.34571 25.3993 8.87313 24.8053C7.92754 23.6169 6.66765 21.9775 5.40861 20.1714C4.14847 18.3636 2.89499 16.3972 1.95809 14.5538C1.01343 12.6947 0.421875 11.0195 0.421875 9.77586C0.421875 4.62367 4.752 0.421875 10.125 0.421875C15.4979 0.421875 19.8281 4.62367 19.8281 9.77586Z"
                    stroke="#1C1D28"
                    strokeOpacity="0.1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7174 14.3799C14.9887 14.332 15.1875 14.0834 15.1875 13.7921V4.51685C15.1875 4.33265 15.0315 4.19259 14.86 4.22288L12.0475 4.71951C11.9119 4.74348 11.8125 4.86776 11.8125 5.01348V9.82699L8.64363 5.63009C8.51639 5.46151 8.31296 5.37899 8.11198 5.41451L5.53534 5.86955L5.53255 5.87005C5.26129 5.91789 5.0625 6.16655 5.0625 6.45789V15.7332C5.0625 15.9173 5.21851 16.0574 5.38996 16.0271L8.20252 15.5304C8.33811 15.5065 8.4375 15.3822 8.4375 15.2364V10.423L11.6064 14.6199C11.7336 14.7885 11.937 14.8709 12.138 14.8355L12.14 14.8351L14.7147 14.3805L14.7174 14.3799Z"
                    fill="#1C1D28"
                />
            </g>
            <defs>
                <clipPath id="clip0_34_418">
                    <rect width="27" height="27" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
